import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import type { ComplianceLockInfo } from 'src/app/core/services/rules-api.service';

@Component({
  selector: 'app-compliance-locks-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './compliance-locks-panel.component.html',
})
export class ComplianceLocksPanelComponent {
  @Input() locks: ComplianceLockInfo[] = [];
  @Input() countryCode = '';
  @Input() loading = false;

  open = false;

  toggle(): void {
    this.open = !this.open;
  }
}
